<!--
 * @Descripttion: 
 * @version: 
 * @Author: WDL
 * @Date: 2023-03-14 16:59:46
 * @LastEditors: WDL
 * @LastEditTime: 2023-03-15 18:49:35
-->
<template>
  <div class="marketContent" >
    <div v-if="BusinessScopeDatalist&&BusinessScopeDatalist.contents&&BusinessScopeDatalist.contents.length>0">
    <div class="pagelist" v-for="(item,index) in BusinessScopeDatalist.contents" :key="index">
        <div class="pictureBox" v-if="item.contentType==='picture'">
            <div v-for="(info,index) in toolPictureOrIconSplitFn(item,'picturesZhCn','picturesEnUs')" :key="index">
                <img :src="info">
            </div>
        </div>
        <div :class="$vuetify.breakpoint.mobile ? 'richtextBox mRichtextBox' : 'richtextBox'" v-if="item.contentType==='rich_text'">
            <div class="richtextMinBox">
                <div class="richtextContent" v-html="lang=='zh'?item.contentZhCn:(item.contentEnUs?item.contentEnUs:item.contentZhCn)"></div>
            </div>
        </div>
        <div class="iconBox" v-if="item.contentType==='icon'">
            <!-- <img :src="lang=='zh'?item.picturesZhCn:item.picturesEnUs"> -->
            <div v-for="(info,index) in toolPictureOrIconSplitFn(item,'picturesZhCn','picturesEnUs')" :key="index">
                <img :src="info">
            </div>
        </div>
        <div class="comboBox" v-if="item.contentType==='combo'">
            <div class="comboHeader">
                <div class="combotitle">{{lang=='zh'?item.contentNameZhCn:(item.contentNameEnUs?item.contentNameEnUs:item.contentNameZhCn)}}</div>
                <div class="comboline"></div>
            </div>
            <vueSeamlessScroll  class="seamless-warp" :data="toolPictureOrIconSplitFn(item,'picturesZhCn','picturesEnUs')"  :class-option="optionCustomer">
                <ul class="item">
                    <li v-for="(info,index) in toolPictureOrIconSplitFn(item,'picturesZhCn','picturesEnUs')" :key="index">
                        <img :src="info">
                    </li>
                </ul>
            </vueSeamlessScroll>

            <!-- <marquee behavior="alternate">
                <div style="display:flex">
                    <div v-for="(info,index) in toolPictureOrIconSplitFn(item,'picturesZhCn','picturesEnUs')" :key="index">
                        <img :src="info">
                    </div>
                </div>
            </marquee> -->
        </div>
    </div>
   </div>
  </div>
</template>

<script>
  import vueSeamlessScroll from "vue-seamless-scroll";
  import workApi from '../../api/vocationalWork'
  export default {
    name: 'vocationalWork',
    components:{vueSeamlessScroll},
    data: () => ({
        BusinessScopeDatalist:[],
        optionCustomer: {
        step: 1,
        limitMoveNum: 1,//限制开始滚动的条数
        openTouch: false,
        waitTime: 50,//滚动的速度
        direction: 2, //方向 0 往下 1 往上 2向左 3向右
        singleWidth: 30,
      }, 

    }),
    computed:{
        //获取当前语言
        lang() {
            return this.$i18n.locale;
        },
    },
    methods:{
       async GetBusinessScope(){
            //获取banner和介绍
            let { data: BusinessScopeData } = await workApi.getAuthBusinessPage();

            this.BusinessScopeDatalist=BusinessScopeData[0];
            BusinessScopeData[0].contents.map((v,i)=>{
                if( v.contentType==='rich_text' ){
                    this.BusinessScopeDatalist.contents[i].contentZhCn = v.contentZhCn ? v.contentZhCn.replace(/\<img/gi,'<img style="width:100%;height:auto" '): v.contentZhCn;
                    this.BusinessScopeDatalist.contents[i].contentEnUs = v.contentEnUs ? v.contentEnUs.replace(/\<img/gi,'<img style="width:100%;height:auto" '): v.contentEnUs;
                }
            })
        },
        toolPictureOrIconSplitFn(info,a,b){
            if(this.lang==='zh'){
                return info[a]?info[a].split(','):[];
            }
            else if(this.lang==='en'){
                return info[b]?info[b].split(','):[];
            }
            else{
                return []
            }   
        }
    },
    mounted(){
      this.GetBusinessScope();
    }
  }
</script>
<style lang="scss" scoped>
.marketContent{
    .pictureBox{
        width: 100%;
    }
    .mRichtextBox{
        // height: calc(450/1136*100vw)!important;
    }
    .richtextBox{
        width: 80%;
        // height: calc(450/1136*60vw);
        margin:40px auto;
        overflow: hidden;
        // background: url(../../assets/images/market/richtextbox.png) no-repeat;
        // background-size: 100% 100%;
        .richtextMinBox{
            // height: calc(((450/1136*60vw)-100));
            height: 100%;
            padding: 5% 2% 2% 2%;
            overflow-y: auto;
        }
        .richtextContent{
            width: 100%;
            height: 100%;
            overflow-y: auto;
            font-size: 16px;
            color: #333;
        }
    }
    .iconBox{
        width: 74%;
        margin:0 auto;
    }
    .comboBox{
        width: 100%;
        .comboHeader{
            .combotitle{
                text-align: center;
                font-size: 34px;
                margin-top:30px;
            }
            .comboline{
                width: 50px;
                background: red;
                height: 4px;
                border-radius: 4px;
                margin:0 auto 14px;
            }
        }
    }
    img{
        width: 100%;
        height: 100%;
        display: block;
    }
    .seamless-warp {
        overflow: hidden;
        height: 100%;
        margin-bottom: 10px;
        ul {
            display: flex;
            li {
                width: 462px;
                margin: 0 12px;
                background-color: #f8f8f8;
                border-radius: 4px;
                list-style: none;
            }
        }
     }
     @media screen and (max-width: 540px) {
        
        .richtextBox{
            margin:30px auto;
            
        }
        .comboBox{
            width: 100%;
            .comboHeader{
                .combotitle{
                    font-size: 20px;
                }
                .comboline{
                    width: 30px;
                    height: 2px;
                    border-radius: 2px;
                }
            }
        }
        .seamless-warp {
            overflow: hidden;
            height: 260px;
            width: 100%;
            ul {
                display: flex;
                li {
                    width: 260px;
                    margin: 0 6px;
                    background-color: #f8f8f8;
                    border-radius: 4px;
                    list-style: none;
                }
            }
     }
    }
}
</style>
